<template>
  <v-card-text class="pa-3 pa-sm-6 lau-checks-tab">
    <v-card elevation="2" rounded="lg" class="mb-4">
      <v-card-text class="pa-2 pa-sm-3">
        <v-tabs
          v-model="secaoAtiva"
          show-arrows
          grow
          color="primary"
          class="lau-checks-sections"
        >
          <v-tab>
            <v-icon :left="$vuetify.breakpoint.smAndUp">mdi-calendar-today</v-icon>
            <span class="d-none d-sm-inline">Hoje</span>
          </v-tab>
          <v-tab>
            <v-icon :left="$vuetify.breakpoint.smAndUp">mdi-format-list-checks</v-icon>
            <span class="d-none d-sm-inline">Habitos</span>
          </v-tab>
          <v-tab>
            <v-icon :left="$vuetify.breakpoint.smAndUp">mdi-calendar-month</v-icon>
            <span class="d-none d-sm-inline">Historico</span>
          </v-tab>
          <v-tab>
            <v-icon :left="$vuetify.breakpoint.smAndUp">mdi-view-dashboard</v-icon>
            <span class="d-none d-sm-inline">Dashboard</span>
          </v-tab>
          <v-tab>
            <v-icon :left="$vuetify.breakpoint.smAndUp">mdi-account-group</v-icon>
            <span class="d-none d-sm-inline">Bruno x Lauana</span>
          </v-tab>
        </v-tabs>

        <div class="notification-actions mt-2">
          <v-btn
            small
            outlined
            color="primary"
            :loading="ativandoNotificacoes"
            :disabled="!notificacoesSuportadas || notificacoesAtivas || notificacoesPermissaoNegada"
            @click="ativarNotificacoes"
          >
            <v-icon left small>{{ notificacoesAtivas ? 'mdi-bell-check-outline' : 'mdi-bell-ring-outline' }}</v-icon>
            {{ textoBotaoNotificacoes }}
          </v-btn>
        </div>
      </v-card-text>
    </v-card>

    <v-tabs-items v-model="secaoAtiva" :touchless="$vuetify.breakpoint.smAndDown">
      <v-tab-item :transition="false" :reverse-transition="false">
        <v-row>
          <v-col cols="12" md="4">
            <v-card elevation="3" rounded="lg" outlined class="mb-4">
              <v-card-title class="primary white--text responsive-title">
                <v-icon left color="white">mdi-calendar-search</v-icon>
                Dia do check
              </v-card-title>
              <v-card-text class="pa-3 pa-sm-4">
                <v-menu
                  v-model="menuDataHoje"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dataHoje"
                      label="Data"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      outlined
                      dense
                      hide-details
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dataHoje"
                    locale="pt-BR"
                    @input="menuDataHoje = false; carregarDia()"
                  ></v-date-picker>
                </v-menu>
                <v-btn block color="primary" outlined class="mt-3" @click="voltarParaHoje">
                  <v-icon left>mdi-calendar-today</v-icon>
                  Hoje
                </v-btn>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" md="8">
            <v-card elevation="3" rounded="lg" outlined>
              <v-card-title class="primary white--text responsive-title">
                <v-icon left color="white">mdi-check-circle-outline</v-icon>
                LauChecks do dia
                <v-spacer></v-spacer>
                <v-btn icon color="white" :loading="carregandoHoje" @click="carregarDia">
                  <v-icon>mdi-refresh</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text class="pa-2 pa-sm-4">
                <v-progress-linear v-if="carregandoHoje" indeterminate color="primary"></v-progress-linear>
                <v-list v-else-if="checksHoje.length" two-line class="pa-0">
                  <v-list-item
                    v-for="item in checksHoje"
                    :key="item.lauCheckId"
                    class="mb-3 rounded lau-check-item"
                  >
                    <v-list-item-avatar :color="statusColor(item.status)" size="44">
                      <v-icon dark>{{ statusIcon(item.status) }}</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-medium">
                        {{ item.nome }}
                      </v-list-item-title>
                      <v-list-item-subtitle class="mt-1">
                        <v-chip x-small :color="statusColor(item.status)" dark class="mr-1">
                          {{ statusText(item.status) }}
                        </v-chip>
                        <v-chip x-small outlined class="mr-1">
                          <v-icon x-small left>mdi-clock-outline</v-icon>
                          {{ formatarHorarioResolvido(item) }}
                        </v-chip>
                        <v-chip v-if="item.flexivelNoPeriodo" x-small outlined>
                          Restam {{ item.restantesNoPeriodo }} de {{ item.metaPeriodo }}
                        </v-chip>
                      </v-list-item-subtitle>
                      <v-list-item-subtitle v-if="item.registro?.observacao" class="text-caption mt-1">
                        {{ item.registro.observacao }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <div class="check-actions">
                        <v-btn small color="success" @click="abrirRegistro(item, 'CONCLUIDO')">
                          <v-icon left small>mdi-check</v-icon>
                          Concluir
                        </v-btn>
                        <v-btn small color="info" outlined @click="abrirRegistro(item, 'PARCIAL')">
                          <v-icon left small>mdi-progress-check</v-icon>
                          Parcial
                        </v-btn>
                        <v-btn small color="warning" outlined @click="abrirRegistro(item, 'PULADO')">
                          <v-icon left small>mdi-debug-step-over</v-icon>
                          Pular
                        </v-btn>
                      </div>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
                <v-alert v-else type="info" text class="ma-2">
                  Nenhum LauCheck previsto para esta data.
                </v-alert>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-tab-item>

      <v-tab-item :transition="false" :reverse-transition="false">
        <v-row>
          <v-col cols="12" class="d-flex justify-end mb-3">
            <v-btn color="primary" @click="abrirCriacao">
              <v-icon left>mdi-plus</v-icon>
              Novo LauCheck
            </v-btn>
          </v-col>
          <v-col cols="12">
            <v-card elevation="3" rounded="lg" outlined>
              <v-card-title class="primary white--text responsive-title">
                <v-icon left color="white">mdi-format-list-checks</v-icon>
                Meus LauChecks
                <v-spacer></v-spacer>
                <v-switch
                  v-model="apenasAtivos"
                  dark
                  hide-details
                  dense
                  label="Ativos"
                  @change="carregarChecks"
                ></v-switch>
              </v-card-title>
              <v-card-text class="pa-2 pa-sm-4">
                <v-progress-linear v-if="carregandoChecks" indeterminate color="primary"></v-progress-linear>
                <v-list v-else-if="checks.length" two-line class="pa-0">
                  <v-list-item
                    v-for="check in checks"
                    :key="check.id"
                    class="mb-2 rounded lau-check-item"
                  >
                    <v-list-item-avatar color="primary" size="42">
                      <v-icon dark>mdi-checkbox-marked-circle-outline</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-medium">{{ check.nome }}</v-list-item-title>
                      <v-list-item-subtitle class="mt-1">
                        <v-chip x-small class="mr-1">{{ enumText(tipoMetaOptions, check.tipoMeta) }}</v-chip>
                        <v-chip x-small outlined>{{ enumText(tipoFrequenciaOptions, check.tipoFrequencia) }}</v-chip>
                      </v-list-item-subtitle>
                      <v-list-item-subtitle v-if="check.descricao" class="text-caption mt-1">
                        {{ check.descricao }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <div class="check-actions">
                        <v-btn small color="primary" outlined @click="abrirEdicao(check)">
                          <v-icon left small>mdi-pencil</v-icon>
                          Editar
                        </v-btn>
                        <v-btn small color="error" outlined @click="desativarCheck(check)">
                          <v-icon left small>mdi-delete-outline</v-icon>
                          Desativar
                        </v-btn>
                      </div>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
                <v-alert v-else type="info" text class="ma-2">
                  Nenhum LauCheck cadastrado.
                </v-alert>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-tab-item>

      <v-tab-item :transition="false" :reverse-transition="false">
        <v-card elevation="3" rounded="lg" outlined>
          <v-card-title class="primary white--text responsive-title">
            <v-icon left color="white">mdi-history</v-icon>
            Historico
          </v-card-title>
          <v-card-text class="pa-3 pa-sm-4">
            <v-row dense>
              <v-col cols="12" md="4">
                <v-select
                  v-model="historicoCheckId"
                  :items="checks"
                  item-text="nome"
                  item-value="id"
                  label="LauCheck"
                  outlined
                  dense
                  @change="carregarHistorico"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4" md="3">
                <v-text-field v-model="historicoInicio" label="Inicio" type="date" outlined dense></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="3">
                <v-text-field v-model="historicoFim" label="Fim" type="date" outlined dense></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="2">
                <v-btn block color="primary" :loading="carregandoHistorico" @click="carregarHistorico">
                  Buscar
                </v-btn>
              </v-col>
            </v-row>
            <v-progress-linear v-if="carregandoHistorico" indeterminate color="primary"></v-progress-linear>
            <div v-else-if="historico.length" class="history-grid">
              <v-card
                v-for="registro in historico"
                :key="registro.id || `${registro.dataHabito}-${registro.status}`"
                outlined
                class="history-day"
              >
                <v-card-text class="pa-3">
                  <div class="text-caption grey--text">{{ formatarData(registro.dataHabito) }}</div>
                  <v-chip small :color="statusColor(registro.status)" dark class="my-2">
                    {{ statusText(registro.status) }}
                  </v-chip>
                  <div v-if="registro.valorRealizado" class="text-body-2">
                    {{ registro.valorRealizado }} {{ registro.unidade }}
                  </div>
                  <div v-if="registro.observacao" class="text-caption mt-1">
                    {{ registro.observacao }}
                  </div>
                </v-card-text>
              </v-card>
            </div>
            <v-alert v-else type="info" text class="ma-2">
              Selecione um LauCheck para ver o historico.
            </v-alert>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item :transition="false" :reverse-transition="false">
        <v-card elevation="3" rounded="lg" outlined>
          <v-card-title class="primary white--text responsive-title">
            <v-icon left color="white">mdi-view-dashboard</v-icon>
            Dashboard
          </v-card-title>
          <v-card-text class="pa-3 pa-sm-4">
            <period-filter
              :inicio.sync="dashboardInicio"
              :fim.sync="dashboardFim"
              :loading="carregandoDashboard"
              @buscar="carregarDashboard"
            />
            <v-progress-linear v-if="carregandoDashboard" indeterminate color="primary"></v-progress-linear>
            <template v-else-if="dashboard">
              <v-row dense class="mb-4">
                <v-col v-for="card in dashboardCards" :key="card.label" cols="6" md="3">
                  <v-card outlined class="metric-card">
                    <v-card-text class="text-center pa-3">
                      <div class="metric-value" :class="card.color">{{ card.value }}</div>
                      <div class="text-caption grey--text">{{ card.label }}</div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-list v-if="dashboard.checklists?.length" two-line class="pa-0">
                <v-list-item v-for="item in dashboard.checklists" :key="item.lauCheckId" class="mb-2 rounded lau-check-item">
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">{{ item.nome }}</v-list-item-title>
                    <v-list-item-subtitle>
                      {{ item.concluidos }} concluidos, {{ item.parciais }} parciais, {{ item.pendentes }} pendentes
                    </v-list-item-subtitle>
                    <v-progress-linear :value="item.percentualCumprimento" color="success" height="10" rounded class="mt-2"></v-progress-linear>
                  </v-list-item-content>
                  <v-list-item-action>
                    <div class="text-h6 success--text">{{ formatarPercentual(item.percentualCumprimento) }}</div>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </template>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item :transition="false" :reverse-transition="false">
        <v-card elevation="3" rounded="lg" outlined>
          <v-card-title class="primary white--text responsive-title">
            <v-icon left color="white">mdi-account-group</v-icon>
            Bruno x Lauana
          </v-card-title>
          <v-card-text class="pa-3 pa-sm-4">
            <period-filter
              :inicio.sync="usuariosInicio"
              :fim.sync="usuariosFim"
              :loading="carregandoUsuarios"
              @buscar="carregarDashboardUsuarios"
            />
            <v-progress-linear v-if="carregandoUsuarios" indeterminate color="primary"></v-progress-linear>
            <v-row v-else dense>
              <v-col v-for="usuario in usuariosOrdenados" :key="usuario.userId" cols="12" md="6">
                <v-card outlined class="user-score-card">
                  <v-card-text class="pa-4">
                    <div class="d-flex align-center justify-space-between mb-3 user-score-header">
                      <div>
                        <div class="text-h6 font-weight-medium">{{ usuario.nome || usuario.username }}</div>
                        <div class="text-caption grey--text">@{{ usuario.username }}</div>
                      </div>
                      <v-chip color="success" dark>{{ formatarPercentual(usuario.percentualCumprimento) }}</v-chip>
                    </div>
                    <v-progress-linear :value="usuario.percentualCumprimento" height="12" color="success" rounded></v-progress-linear>
                    <v-row dense class="mt-3 text-center">
                      <v-col cols="3"><strong>{{ usuario.previstos }}</strong><div class="text-caption">prev.</div></v-col>
                      <v-col cols="3"><strong>{{ usuario.concluidos }}</strong><div class="text-caption">conc.</div></v-col>
                      <v-col cols="3"><strong>{{ usuario.parciais }}</strong><div class="text-caption">parc.</div></v-col>
                      <v-col cols="3"><strong>{{ usuario.pendentes }}</strong><div class="text-caption">pend.</div></v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>

    <v-dialog v-model="dialogCheck" max-width="760px" :fullscreen="$vuetify.breakpoint.xs" scrollable persistent>
      <v-card>
        <v-card-title class="primary white--text responsive-title">
          <v-icon left color="white">{{ checkEditando ? 'mdi-pencil' : 'mdi-plus' }}</v-icon>
          {{ checkEditando ? 'Editar LauCheck' : 'Novo LauCheck' }}
          <v-spacer></v-spacer>
          <v-btn icon dark @click="fecharDialogCheck"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="pa-3 pa-sm-5">
          <v-form ref="formCheck" v-model="formCheckValido">
            <v-row dense>
              <v-col cols="12" md="7">
                <v-text-field v-model="checkForm.nome" label="Nome" outlined dense :rules="[v => !!v || 'Nome obrigatorio']"></v-text-field>
              </v-col>
              <v-col cols="12" md="5">
                <v-select v-model="checkForm.tipoMeta" :items="tipoMetaOptions" label="Tipo de meta" outlined dense></v-select>
              </v-col>
              <v-col cols="12">
                <v-textarea v-model="checkForm.descricao" label="Descricao" outlined dense rows="2"></v-textarea>
              </v-col>
              <v-col v-if="checkForm.tipoMeta !== 'SIM_NAO'" cols="12" sm="6">
                <v-text-field v-model.number="checkForm.metaQuantidade" label="Meta" type="number" min="0" step="0.1" outlined dense></v-text-field>
              </v-col>
              <v-col v-if="checkForm.tipoMeta !== 'SIM_NAO'" cols="12" sm="6">
                <v-text-field v-model="checkForm.unidadeMeta" label="Unidade" outlined dense placeholder="hora, litros, paginas..."></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select v-model="checkForm.tipoFrequencia" :items="tipoFrequenciaOptions" label="Frequencia" outlined dense></v-select>
              </v-col>
              <v-col v-if="exibeMetaFrequencia" cols="12" sm="6">
                <v-text-field v-model.number="checkForm.metaFrequencia" label="Vezes no periodo" type="number" min="1" outlined dense></v-text-field>
              </v-col>
              <v-col v-if="checkForm.tipoFrequencia === 'DIAS_DA_SEMANA'" cols="12">
                <v-select v-model="checkForm.diasSemana" :items="diasSemanaOptions" label="Dias da semana" outlined dense multiple chips></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select v-model="checkForm.periodoReferencia" :items="periodoOptions" label="Periodo de referencia" outlined dense></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="checkForm.horarioReferencia"
                  label="Horario padrao"
                  type="time"
                  outlined
                  dense
                  hint="Opcional. Usado como referencia geral."
                  persistent-hint
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select v-model="checkForm.prazoRegistro" :items="prazoOptions" label="Prazo de registro" outlined dense></v-select>
              </v-col>
              <v-col v-if="checkForm.tipoFrequencia === 'DIAS_DA_SEMANA'" cols="12">
                <v-card outlined class="day-overrides-card">
                  <v-card-title class="py-2 px-3 responsive-title">
                    <v-icon left color="primary">mdi-calendar-clock</v-icon>
                    Horarios por dia
                    <v-spacer></v-spacer>
                    <v-btn small color="primary" outlined @click="adicionarHorarioPorDia">
                      <v-icon left small>mdi-plus</v-icon>
                      Adicionar
                    </v-btn>
                  </v-card-title>
                  <v-card-text class="pa-3">
                    <v-alert dense text type="info" class="mb-3">
                      Use apenas para sobrescrever o periodo/horario padrao em dias especificos.
                    </v-alert>

                    <div
                      v-for="(horario, index) in checkForm.horariosPorDia"
                      :key="`horario-${index}`"
                      class="day-override-row"
                    >
                      <v-row dense align="center">
                        <v-col cols="12" sm="4">
                          <v-select
                            v-model="horario.diaSemana"
                            :items="diasSemanaOptions"
                            label="Dia"
                            outlined
                            dense
                            hide-details
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="4">
                          <v-select
                            v-model="horario.periodoReferencia"
                            :items="periodoOptions"
                            label="Periodo"
                            outlined
                            dense
                            hide-details
                          ></v-select>
                        </v-col>
                        <v-col cols="10" sm="3">
                          <v-text-field
                            v-model="horario.horarioReferencia"
                            label="Horario"
                            type="time"
                            outlined
                            dense
                            hide-details
                          ></v-text-field>
                        </v-col>
                        <v-col cols="2" sm="1" class="text-right">
                          <v-btn icon color="error" @click="removerHorarioPorDia(index)">
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </div>

                    <div v-if="!checkForm.horariosPorDia.length" class="text-caption grey--text">
                      Nenhuma sobrescrita cadastrada.
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="pa-3 responsive-actions">
          <v-spacer></v-spacer>
          <v-btn text @click="fecharDialogCheck">Cancelar</v-btn>
          <v-btn color="primary" :loading="salvandoCheck" :disabled="!formCheckValido" @click="salvarCheck">
            <v-icon left>mdi-content-save</v-icon>
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogRegistro" max-width="560px" :fullscreen="$vuetify.breakpoint.xs" scrollable persistent>
      <v-card>
        <v-card-title :class="`${statusColor(registroForm.status)} white--text responsive-title`">
          <v-icon left color="white">{{ statusIcon(registroForm.status) }}</v-icon>
          Registrar LauCheck
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialogRegistro = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="pa-3 pa-sm-5">
          <div class="text-subtitle-1 font-weight-medium mb-3">{{ registroItem?.nome }}</div>
          <v-row dense>
            <v-col cols="12" sm="6">
              <v-text-field v-model="registroForm.dataHabito" type="date" label="Data do habito" outlined dense></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select v-model="registroForm.status" :items="statusOptions" label="Status" outlined dense></v-select>
            </v-col>
            <v-col v-if="registroForm.status !== 'PULADO'" cols="12" sm="6">
              <v-text-field v-model.number="registroForm.valorRealizado" label="Valor realizado" type="number" min="0" step="0.1" outlined dense></v-text-field>
            </v-col>
            <v-col v-if="registroForm.status !== 'PULADO'" cols="12" sm="6">
              <v-text-field v-model="registroForm.unidade" label="Unidade" outlined dense></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-select v-model="registroForm.periodoRealizado" :items="periodoOptions" label="Periodo realizado" outlined dense></v-select>
            </v-col>
            <v-col cols="12">
              <v-textarea v-model="registroForm.observacao" label="Observacao" outlined dense rows="3"></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pa-3 responsive-actions">
          <v-spacer></v-spacer>
          <v-btn text @click="dialogRegistro = false">Cancelar</v-btn>
          <v-btn color="primary" :loading="salvandoRegistro" @click="salvarRegistro">
            <v-icon left>mdi-check</v-icon>
            Registrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card-text>
</template>

<script>
import lauChecksService from '@/services/lauChecksService';
import pushNotificationService from '@/services/pushNotificationService';

const hojeIso = () => new Date().toISOString().substr(0, 10);

const PeriodFilter = {
  props: {
    inicio: String,
    fim: String,
    loading: Boolean,
  },
  template: `
    <v-row dense class="mb-3">
      <v-col cols="12" sm="5">
        <v-text-field :value="inicio" label="Inicio" type="date" outlined dense @input="$emit('update:inicio', $event)"></v-text-field>
      </v-col>
      <v-col cols="12" sm="5">
        <v-text-field :value="fim" label="Fim" type="date" outlined dense @input="$emit('update:fim', $event)"></v-text-field>
      </v-col>
      <v-col cols="12" sm="2">
        <v-btn block color="primary" :loading="loading" @click="$emit('buscar')">Buscar</v-btn>
      </v-col>
    </v-row>
  `,
};

export default {
  name: 'LauChecksTab',

  components: {
    PeriodFilter,
  },

  data() {
    return {
      secaoAtiva: 0,
      dataHoje: hojeIso(),
      menuDataHoje: false,
      checksHoje: [],
      checks: [],
      apenasAtivos: true,
      historicoCheckId: null,
      historicoInicio: '',
      historicoFim: '',
      historico: [],
      dashboardInicio: '',
      dashboardFim: '',
      usuariosInicio: '',
      usuariosFim: '',
      dashboard: null,
      usuarios: [],
      carregandoHoje: false,
      carregandoChecks: false,
      carregandoHistorico: false,
      carregandoDashboard: false,
      carregandoUsuarios: false,
      dialogCheck: false,
      dialogRegistro: false,
      checkEditando: null,
      formCheckValido: false,
      salvandoCheck: false,
      salvandoRegistro: false,
      ativandoNotificacoes: false,
      notificacoesSuportadas: false,
      notificacoesAtivas: false,
      notificacoesPermissaoNegada: false,
      registroItem: null,
      checkForm: this.novoCheckForm(),
      registroForm: this.novoRegistroForm(),
      tipoMetaOptions: [
        { text: 'Sim/Nao', value: 'SIM_NAO' },
        { text: 'Duracao', value: 'DURACAO' },
        { text: 'Quantidade', value: 'QUANTIDADE' },
      ],
      tipoFrequenciaOptions: [
        { text: 'Todos os dias', value: 'TODOS_OS_DIAS' },
        { text: 'Dias da semana', value: 'DIAS_DA_SEMANA' },
        { text: 'Vezes por semana', value: 'VEZES_POR_SEMANA' },
        { text: 'Vezes por mes', value: 'VEZES_POR_MES' },
      ],
      diasSemanaOptions: [
        { text: 'Domingo', value: 'DOMINGO' },
        { text: 'Segunda', value: 'SEGUNDA' },
        { text: 'Terca', value: 'TERCA' },
        { text: 'Quarta', value: 'QUARTA' },
        { text: 'Quinta', value: 'QUINTA' },
        { text: 'Sexta', value: 'SEXTA' },
        { text: 'Sabado', value: 'SABADO' },
      ],
      periodoOptions: [
        { text: 'Sem horario', value: 'SEM_HORARIO' },
        { text: 'Manha', value: 'MANHA' },
        { text: 'Tarde', value: 'TARDE' },
        { text: 'Noite', value: 'NOITE' },
        { text: 'Horario especifico', value: 'HORARIO_ESPECIFICO' },
      ],
      prazoOptions: [
        { text: 'Mesmo dia', value: 'MESMO_DIA' },
        { text: 'Ate dia seguinte', value: 'ATE_DIA_SEGUINTE' },
        { text: 'Ultimos 7 dias', value: 'ULTIMOS_7_DIAS' },
        { text: 'Sem limite', value: 'SEM_LIMITE' },
      ],
      statusOptions: [
        { text: 'Pendente', value: 'PENDENTE' },
        { text: 'Concluido', value: 'CONCLUIDO' },
        { text: 'Parcial', value: 'PARCIAL' },
        { text: 'Pulado', value: 'PULADO' },
      ],
      ultimaCargaSecao: {},
    };
  },

  computed: {
    exibeMetaFrequencia() {
      return ['VEZES_POR_SEMANA', 'VEZES_POR_MES'].includes(this.checkForm.tipoFrequencia);
    },

    dashboardCards() {
      if (!this.dashboard) return [];
      return [
        { label: 'Previstos', value: this.dashboard.previstos || 0, color: 'primary--text' },
        { label: 'Concluidos', value: this.dashboard.concluidos || 0, color: 'success--text' },
        { label: 'Pendentes', value: this.dashboard.pendentes || 0, color: 'warning--text' },
        { label: 'Cumprimento', value: this.formatarPercentual(this.dashboard.percentualCumprimento), color: 'info--text' },
      ];
    },

    usuariosOrdenados() {
      return [...this.usuarios].sort((a, b) => (b.percentualCumprimento || 0) - (a.percentualCumprimento || 0));
    },

    textoBotaoNotificacoes() {
      if (!this.notificacoesSuportadas) return 'Notificacoes indisponiveis';
      if (this.notificacoesPermissaoNegada) return 'Notificacoes bloqueadas';
      if (this.notificacoesAtivas) return 'Notificacoes ativas';
      return 'Ativar notificacoes';
    },
  },

  mounted() {
    this.atualizarEstadoNotificacoes();
    this.carregarSecaoAtual();
  },

  watch: {
    secaoAtiva() {
      this.carregarSecaoAtual();
    },
  },

  methods: {
    refreshDados() {
      this.carregarSecaoAtual(true);
    },

    async atualizarEstadoNotificacoes() {
      this.notificacoesSuportadas = pushNotificationService.suportaPushNotifications();
      this.notificacoesPermissaoNegada = this.notificacoesSuportadas && Notification.permission === 'denied';

      if (!this.notificacoesSuportadas) return;

      try {
        const subscription = await pushNotificationService.obterSubscriptionAtual();
        this.notificacoesAtivas = !!subscription;
      } catch (error) {
        this.notificacoesAtivas = false;
      }
    },

    async ativarNotificacoes() {
      this.ativandoNotificacoes = true;
      try {
        await pushNotificationService.ativarNotificacoes();
        this.notificacoesAtivas = true;
        this.notificacoesPermissaoNegada = false;
        this.$toast.success('Notificacoes ativadas');
      } catch (error) {
        this.notificacoesPermissaoNegada = typeof Notification !== 'undefined' && Notification.permission === 'denied';
        this.$toast.error(error.message || 'Erro ao ativar notificacoes');
      } finally {
        this.ativandoNotificacoes = false;
      }
    },

    novoCheckForm() {
      return {
        nome: '',
        descricao: '',
        tipoMeta: 'SIM_NAO',
        metaQuantidade: null,
        unidadeMeta: '',
        tipoFrequencia: 'TODOS_OS_DIAS',
        diasSemana: [],
        metaFrequencia: null,
        periodoReferencia: 'SEM_HORARIO',
        horarioReferencia: '',
        horariosPorDia: [],
        prazoRegistro: 'MESMO_DIA',
      };
    },

    novoRegistroForm() {
      return {
        dataHabito: this?.dataHoje || hojeIso(),
        status: 'CONCLUIDO',
        valorRealizado: null,
        unidade: '',
        periodoRealizado: 'SEM_HORARIO',
        observacao: '',
      };
    },

    async carregarDados() {
      await this.carregarSecaoAtual(true);
    },

    async carregarSecaoAtual(forcar = false) {
      if (!forcar && this.ultimaCargaSecao[this.secaoAtiva]) return;

      if (this.secaoAtiva === 0) {
        await this.carregarDia();
      } else if (this.secaoAtiva === 1) {
        await this.carregarChecks();
      } else if (this.secaoAtiva === 2) {
        if (!this.checks.length) {
          await this.carregarChecks();
        }
        await this.carregarHistorico();
      } else if (this.secaoAtiva === 3) {
        await this.carregarDashboard();
      } else if (this.secaoAtiva === 4) {
        await this.carregarDashboardUsuarios();
      }

      this.$set(this.ultimaCargaSecao, this.secaoAtiva, Date.now());
    },

    async carregarDia() {
      this.carregandoHoje = true;
      try {
        const response = this.dataHoje === hojeIso()
          ? await lauChecksService.listarHoje()
          : await lauChecksService.listarDia(this.dataHoje);
        this.checksHoje = response.data || [];
      } catch (error) {
        console.error('Erro ao carregar LauChecks do dia:', error);
        this.$toast.error('Erro ao carregar LauChecks do dia');
      } finally {
        this.carregandoHoje = false;
      }
    },

    async carregarChecks() {
      this.carregandoChecks = true;
      try {
        const response = await lauChecksService.listar(this.apenasAtivos);
        this.checks = (response.data || []).map(check => ({
          ...check,
          id: check.id !== undefined ? check.id : check.lauCheckId,
        }));
        if (!this.historicoCheckId && this.checks.length) {
          this.historicoCheckId = this.checks[0].id;
        }
      } catch (error) {
        console.error('Erro ao carregar LauChecks:', error);
        this.$toast.error('Erro ao carregar LauChecks');
      } finally {
        this.carregandoChecks = false;
      }
    },

    voltarParaHoje() {
      this.dataHoje = hojeIso();
      this.carregarDia();
    },

    abrirCriacao() {
      this.checkEditando = null;
      this.checkForm = this.novoCheckForm();
      this.dialogCheck = true;
    },

    abrirEdicao(check) {
      this.checkEditando = check;
      this.checkForm = {
        ...this.novoCheckForm(),
        ...check,
        diasSemana: check.diasSemana || [],
        horariosPorDia: (check.horariosPorDia || []).map(horario => ({ ...horario })),
      };
      this.dialogCheck = true;
    },

    fecharDialogCheck() {
      this.dialogCheck = false;
      this.checkEditando = null;
      this.checkForm = this.novoCheckForm();
    },

    montarPayloadCheck() {
      const payload = { ...this.checkForm };
      payload.horariosPorDia = (payload.horariosPorDia || [])
        .filter(horario => horario.diaSemana && horario.periodoReferencia)
        .map(horario => ({
          diaSemana: horario.diaSemana,
          periodoReferencia: horario.periodoReferencia,
          horarioReferencia: horario.horarioReferencia || null,
        }));

      if (!payload.horarioReferencia) {
        delete payload.horarioReferencia;
      }

      if (payload.tipoMeta === 'SIM_NAO') {
        delete payload.metaQuantidade;
        delete payload.unidadeMeta;
      }
      if (payload.tipoFrequencia !== 'DIAS_DA_SEMANA') {
        delete payload.diasSemana;
        payload.horariosPorDia = [];
      }
      if (!['VEZES_POR_SEMANA', 'VEZES_POR_MES'].includes(payload.tipoFrequencia)) {
        delete payload.metaFrequencia;
      }
      return payload;
    },

    adicionarHorarioPorDia() {
      const primeiroDia = this.checkForm.diasSemana?.[0] || 'SEGUNDA';
      this.checkForm.horariosPorDia.push({
        diaSemana: primeiroDia,
        periodoReferencia: 'HORARIO_ESPECIFICO',
        horarioReferencia: '',
      });
    },

    removerHorarioPorDia(index) {
      this.checkForm.horariosPorDia.splice(index, 1);
    },

    async salvarCheck() {
      if (!this.$refs.formCheck.validate()) return;
      this.salvandoCheck = true;
      try {
        const payload = this.montarPayloadCheck();
        if (this.checkEditando) {
          await lauChecksService.atualizar(this.checkEditando.id, payload);
          this.$toast.success('LauCheck atualizado');
        } else {
          await lauChecksService.criar(payload);
          this.$toast.success('LauCheck criado');
        }
        this.fecharDialogCheck();
        await Promise.all([this.carregarChecks(), this.carregarDia(), this.carregarDashboard(), this.carregarDashboardUsuarios()]);
      } catch (error) {
        console.error('Erro ao salvar LauCheck:', error);
        this.$toast.error(error.response?.data?.message || 'Erro ao salvar LauCheck');
      } finally {
        this.salvandoCheck = false;
      }
    },

    async desativarCheck(check) {
      if (!confirm(`Deseja desativar "${check.nome}"?`)) return;
      try {
        await lauChecksService.desativar(check.id);
        this.$toast.success('LauCheck desativado');
        await Promise.all([this.carregarChecks(), this.carregarDia()]);
      } catch (error) {
        console.error('Erro ao desativar LauCheck:', error);
        this.$toast.error('Erro ao desativar LauCheck');
      }
    },

    abrirRegistro(item, status) {
      this.registroItem = item;
      this.registroForm = {
        ...this.novoRegistroForm(),
        dataHabito: item.dataHabito || this.dataHoje,
        status,
        unidade: item.registro?.unidade || '',
        valorRealizado: item.registro?.valorRealizado || null,
        observacao: item.registro?.observacao || '',
      };
      this.dialogRegistro = true;
    },

    async salvarRegistro() {
      if (!this.registroItem) return;
      this.salvandoRegistro = true;
      try {
        const payload = { ...this.registroForm };
        if (payload.status === 'PULADO') {
          delete payload.valorRealizado;
          delete payload.unidade;
        }
        await lauChecksService.registrar(this.registroItem.lauCheckId, payload);
        this.$toast.success('Registro salvo');
        this.dialogRegistro = false;
        await Promise.all([this.carregarDia(), this.carregarDashboard(), this.carregarDashboardUsuarios()]);
      } catch (error) {
        console.error('Erro ao registrar LauCheck:', error);
        this.$toast.error(error.response?.data?.message || 'Erro ao registrar LauCheck');
      } finally {
        this.salvandoRegistro = false;
      }
    },

    async carregarHistorico() {
      if (!this.historicoCheckId) return;
      this.carregandoHistorico = true;
      try {
        const response = await lauChecksService.listarRegistros(this.historicoCheckId, this.historicoInicio, this.historicoFim);
        this.historico = response.data || [];
      } catch (error) {
        console.error('Erro ao carregar historico:', error);
        this.$toast.error('Erro ao carregar historico');
      } finally {
        this.carregandoHistorico = false;
      }
    },

    async carregarDashboard() {
      this.carregandoDashboard = true;
      try {
        const response = await lauChecksService.dashboard(this.dashboardInicio, this.dashboardFim);
        this.dashboard = response.data;
      } catch (error) {
        console.error('Erro ao carregar dashboard:', error);
        this.$toast.error('Erro ao carregar dashboard');
      } finally {
        this.carregandoDashboard = false;
      }
    },

    async carregarDashboardUsuarios() {
      this.carregandoUsuarios = true;
      try {
        const response = await lauChecksService.dashboardUsuarios(this.usuariosInicio, this.usuariosFim);
        this.usuarios = response.data || [];
      } catch (error) {
        console.error('Erro ao carregar dashboard de usuarios:', error);
        this.$toast.error('Erro ao carregar dashboard de usuarios');
      } finally {
        this.carregandoUsuarios = false;
      }
    },

    enumText(options, value) {
      return options.find(option => option.value === value)?.text || value || '-';
    },

    formatarHorarioResolvido(item) {
      const periodo = this.enumText(this.periodoOptions, item.periodoReferencia);
      if (item.horarioReferencia) {
        return `${periodo} - ${item.horarioReferencia}`;
      }
      return periodo;
    },

    statusText(status) {
      return this.enumText(this.statusOptions, status);
    },

    statusColor(status) {
      const colors = {
        PENDENTE: 'grey',
        CONCLUIDO: 'success',
        PARCIAL: 'info',
        PULADO: 'warning',
      };
      return colors[status] || 'grey';
    },

    statusIcon(status) {
      const icons = {
        PENDENTE: 'mdi-clock-outline',
        CONCLUIDO: 'mdi-check-circle',
        PARCIAL: 'mdi-progress-check',
        PULADO: 'mdi-debug-step-over',
      };
      return icons[status] || 'mdi-help-circle';
    },

    formatarData(data) {
      if (!data) return '-';
      if (/^\d{4}-\d{2}-\d{2}$/.test(data)) {
        const [ano, mes, dia] = data.split('-');
        return `${dia}/${mes}/${ano}`;
      }
      return new Date(data).toLocaleDateString('pt-BR');
    },

    formatarPercentual(valor) {
      return `${Number(valor || 0).toFixed(1)}%`;
    },
  },
};
</script>

<style scoped>
.lau-checks-tab {
  overflow-x: hidden;
}

.lau-check-item {
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.check-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
}

.notification-actions {
  display: flex;
  justify-content: flex-end;
}

.history-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 12px;
}

.history-day,
.metric-card,
.user-score-card,
.day-overrides-card {
  border-radius: 8px;
}

.day-override-row {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  padding: 10px 0;
}

.day-override-row:last-child {
  border-bottom: 0;
  padding-bottom: 0;
}

.metric-value {
  font-size: clamp(22px, 7vw, 32px);
  font-weight: 700;
  line-height: 1.1;
}

.responsive-actions {
  flex-wrap: wrap;
  gap: 8px;
}

.responsive-actions .v-btn {
  margin-left: 0 !important;
}

@media (max-width: 599px) {
  .lau-checks-sections ::v-deep .v-tab {
    min-width: 54px;
    padding: 0 6px;
  }

  .responsive-title {
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
    line-height: 1.25;
    word-break: break-word;
  }

  .responsive-title .spacer {
    display: none;
  }

  .lau-check-item {
    align-items: flex-start;
    flex-wrap: wrap;
    padding: 8px !important;
  }

  .lau-check-item ::v-deep .v-list-item__content {
    min-width: 0;
  }

  .lau-check-item ::v-deep .v-list-item__action {
    flex: 1 1 100%;
    margin: 8px 0 0 56px !important;
    align-items: stretch;
  }

  .check-actions {
    justify-content: stretch;
  }

  .notification-actions {
    justify-content: stretch;
  }

  .notification-actions .v-btn {
    flex: 1 1 100%;
  }

  .check-actions .v-btn {
    flex: 1 1 100%;
  }

  .responsive-actions {
    justify-content: stretch;
  }

  .responsive-actions .spacer {
    display: none;
  }

  .responsive-actions .v-btn {
    flex: 1 1 100%;
  }

  .history-grid {
    grid-template-columns: 1fr;
  }

  .user-score-header {
    align-items: flex-start !important;
    flex-direction: column;
    gap: 8px;
  }

  ::v-deep .v-dialog {
    margin: 8px !important;
    max-height: calc(100% - 16px) !important;
  }

  ::v-deep .v-dialog--fullscreen {
    margin: 0 !important;
    max-height: 100% !important;
  }

  ::v-deep .v-dialog .v-card__text {
    overflow-y: auto;
  }

  ::v-deep .v-list-item__title,
  ::v-deep .v-list-item__subtitle {
    overflow: visible;
    text-overflow: clip;
    white-space: normal;
    word-break: break-word;
  }

  ::v-deep .v-chip {
    max-width: 100%;
  }

  ::v-deep .v-chip .v-chip__content {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  ::v-deep .v-picker {
    width: 100%;
    max-width: 100%;
  }
}
</style>
